<div class="flip-card" data-testid="flip-card">
  <div
    *ngFor="let number of activeValues; first as isFirst"
    class="flip-card__card"
    [class.flip-card__card--current]="isFirst"
    [class.flip-card__card--previous]="!isFirst"
    data-testid="flip-card-card">
    <div class="flip-card__value" data-testid="flip-card-value">
      <div class="flip-card__value-top" data-testid="flip-card-top">
        <div class="flip-card__digit flip-card__digit-top" data-testid="flip-card-top-value">
          {{ number }}
        </div>
      </div>

      <div class="flip-card__value-bottom" data-testid="flip-card-bottom">
        <div class="flip-card__digit flip-card__digit-bottom" data-testid="flip-card-bottom-value">
          {{ number }}
        </div>
      </div>
    </div>
  </div>
</div>
